module.exports = __webpack_public_path__ + "img/dis03.1cfdef78.png";